import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Compass: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.992 1.062L10.9919 2.124L10.7813 2.19055C9.03197 2.74337 7.86679 4.47403 8.01502 6.2994C8.04953 6.72422 8.12717 7.06966 8.27983 7.47739L8.33427 7.62278L6.84948 10.8074L5.36472 13.992H4.18236H3V15V16.008H3.708C4.0974 16.008 4.416 16.012 4.416 16.0168C4.416 16.0217 3.67498 17.612 2.76927 19.5508C1.86355 21.4897 1.11811 23.0976 1.11274 23.124C1.10419 23.166 1.21579 23.2242 2.00427 23.5892C2.49999 23.8187 2.90878 24.0023 2.91269 23.9972C2.91658 23.9922 3.75593 22.1928 4.7779 19.9986L6.636 16.0091L8.814 16.0086L10.992 16.008V17.004V18H12H13.008V17.004V16.008L15.186 16.0086L17.364 16.0092L19.2221 19.9986C20.244 22.1928 21.0834 23.9922 21.0874 23.9973C21.0913 24.0024 21.4998 23.8188 21.9952 23.5893C22.7879 23.222 22.8944 23.1663 22.8847 23.124C22.8786 23.0976 22.1334 21.4898 21.2288 19.5512C20.3242 17.6125 19.584 16.0222 19.584 16.0172C19.584 16.0121 19.9026 16.008 20.292 16.008H21V15V13.992H19.8176H18.6352L17.1504 10.8076L15.6656 7.62317L15.7201 7.47758C15.9432 6.88176 16.0325 6.28474 15.9853 5.706C15.958 5.37214 15.9352 5.23829 15.8535 4.932C15.5149 3.66377 14.483 2.59008 13.2187 2.19055L13.0081 2.124L13.008 1.062L13.008 0H12H10.992L10.992 1.062ZM11.688 4.02314C10.8906 4.17677 10.292 4.71161 10.0744 5.46482C9.99631 5.73518 9.99631 6.26482 10.0744 6.53518C10.2689 7.2084 10.7916 7.73107 11.4648 7.92557C11.7352 8.00369 12.2648 8.00369 12.5352 7.92557C13.2084 7.73107 13.7311 7.2084 13.9256 6.53518C14.0037 6.26482 14.0037 5.73518 13.9256 5.46482C13.7326 4.79678 13.2088 4.26962 12.5479 4.0783C12.3752 4.0283 11.8396 3.99394 11.688 4.02314ZM8.67547 11.646C8.08395 12.9165 7.59576 13.9641 7.59058 13.974C7.58539 13.9839 8.34862 13.992 9.28659 13.992H10.992V12.996V12H12H13.008V12.996V13.992H14.7123H16.4167L16.3829 13.914C16.3034 13.7304 14.2551 9.35112 14.2431 9.3391C14.2358 9.3318 14.2114 9.33725 14.1889 9.35124C13.6683 9.67464 13.1328 9.87593 12.564 9.96199C12.316 9.9995 11.6823 9.99934 11.436 9.96168C10.8952 9.87898 10.3762 9.69408 9.9462 9.4309C9.86093 9.3787 9.78211 9.336 9.77105 9.336C9.75999 9.336 9.26698 10.3755 8.67547 11.646Z'
        fill={fill}
      />
    </svg>
  )
}

export default Compass
